module.exports = __webpack_public_path__ + "static/media/RightCircle.da8a9de2.svg";